import { Injectable } from '@angular/core'

// interface RouteDataInterface {
//     [key: string]: any
// }
// implements RouteDataInterface

@Injectable()
export class RouteData {
    data: any;
    [key: string]: any
}
